<ng-container *ngIf="{
  request: requestSystemDevicesStatus$ | async,
} as resolver">
  <ng-container *ngIf="devices$ | async; else skeleton">
    <!-- Reusable template for compare checkbox -->
    <ng-template
      #compareCheckbox
      let-device="device"
      let-extraClass="extraClass">
      <mat-checkbox
        *ngIf="device.type === 'inverter' && compareMode"
        color="primary"
        [ngClass]="extraClass"
        [checked]="device.serial | apply: isDeviceSelectedForComparison"
        [attr.aria-label]="labels.compareCheckboxAriaLabel"
        (click)="$event.stopPropagation()"
        (change)="compare.emit(device.serial)">
      </mat-checkbox>
    </ng-template>

    <lib-block-title
      data-testid="device-list-title"
      id="device-list-title"
      [title]="labels.title">
    </lib-block-title>
    <div
      *ngIf="compareMode"
      class="fx-col fx-gap-3"
      id="selected-devices">
      <div class="tw-text-sm tw-text-grey-400 fx-row fx-align-center fx-gap-2">
        <mat-icon class="tw-text-grey-300 s-6 min-s-6">info</mat-icon>
        <span>
          {{ labels.compareLimitLabel }}
        </span>
      </div>
      <div
        *ngIf="selectedDevicesForComparison.length"
        class="mt-3">
        <span class="tw-text-sm tw-text-grey-500">
          {{ labels.selectedDevices || 'Selected' }} ({{ selectedDevicesForComparison.length }}):
        </span>
        <mat-chip-listbox>
          <mat-chip
            *ngFor="let selected of selectedDevicesForComparison"
            class="tw-text-grey-500 tw-bg-grey-50">
            {{ selected }}
          </mat-chip>
        </mat-chip-listbox>
      </div>
    </div>
    <section id="add-device">
      <ng-content select="[add-device]"></ng-content>
    </section>
    <section
      id="device-table"
      class="tw-w-full overflow-hidden border-1 radius-4 tw-border-grey-100">
      <table
        mat-table
        class="customer-table"
        [dataSource]="dataSource">
        <ng-container matColumnDef="serial">
          <th
            *matHeaderCellDef
            mat-header-cell>
            {{ labels.serial }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell
            class="!tw-font-base">
            <ng-container *ngTemplateOutlet="content; context: { value: element.serial }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th
            *matHeaderCellDef
            mat-header-cell>
            {{ labels.type }}
          </th>
          <td
            *matCellDef="let element"
            class="text-uppercase"
            mat-cell>
            <ng-container *ngTemplateOutlet="content; context: { value: element.type }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th
            *matHeaderCellDef
            mat-header-cell>
            {{ labels.status }}
          </th>
          <td
            *matCellDef="let device"
            mat-cell>
            <ng-container *ngTemplateOutlet="deviceStatusTemplate; context: { $implicit: device }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="logger">
          <th
            *matHeaderCellDef
            mat-header-cell>
            {{ labels.logger }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell >
            <ng-container *ngTemplateOutlet="content; context: { value: element.logger }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th
            *matHeaderCellDef
            mat-header-cell>
            {{ labels.actions }}
          </th>
          <td
            *matCellDef="let element"
            mat-cell>
            <ng-container *ngIf="!element.uninstalled; else noActions">
              <div class="d-inline-flex fx-align-center fx-justify-center">
                <ng-container *ngTemplateOutlet="compareCheckbox; context: {device: element, extraClass: 'tw-mr-2'}"></ng-container>
                <button
                  mat-icon-button
                  class="tw-text-grey-400 fx-center fx-row s-10"
                  (click)="view.emit(element.serial)">
                  <mat-icon class="s-6">visibility</mat-icon>
                </button>
              </div>
            </ng-container>
            <ng-template #noActions>
              <span class="tw-text-grey-400 tw-mr-2 text-style-italic">
                {{ labels.statusUninstalled }}
              </span>
            </ng-template>
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="displayedColumns"
          mat-header-row>
        </tr>
        <tr
          *matRowDef="let row; columns: displayedColumns; let odd = odd"
          data-testid="device-list-row"
          class="hover"
          mat-row
          [class.bg-grey-100]="odd"
          [class.device-selected]="row.serial | apply: isDeviceSelectedForComparison">
        </tr>

        <tr
          *matNoDataRow
          class="mat-row">
          <td
            class="tw-text-center tw-font-medium tw-p-2 text-grey-400 py-10"
            [attr.colspan]="displayedColumns.length">
            {{ labels.noDevice }}
          </td>
        </tr>
      </table>
    </section>
    <section
      id="device-list"
      class="tw-border-grey-100 border-1 radius-4">
      <div
        *ngFor="let device of dataSource.data; let first = first; let odd = odd"
        class="tw-flex tw-flex-col tw-p-2 tw-border-grey-100 hover"
        [class.bg-grey-100]="odd"
        [class.device-selected]="device.serial | apply: isDeviceSelectedForComparison"
        [class.tw-border-t]="!first">
        <div class="tw-flex tw-justify-between tw-align-middle">
          <div class="tw-font-medium tw-text-sm tw-text-grey-400 h-9 fx-row fx-center ellipsed">
            <ng-container *ngTemplateOutlet="content; context: { value: device.serial }"></ng-container>
          </div>
          <div class="fx-row fx-gap-2 fx-align-center">
            <ng-container *ngTemplateOutlet="deviceStatusTemplate; context: { $implicit: device }"></ng-container>
            <ng-container *ngIf="!device.uninstalled">
              <div class="d-inline-flex fx-align-center fx-justify-center">
                <ng-container *ngTemplateOutlet="compareCheckbox; context: {device: device, extraClass: 'tw-text-sm'}"></ng-container>
                <button
                  mat-icon-button
                  class="tw-text-grey-400 s-10 fx-row fx-center"
                  (click)="view.emit(device.serial)">
                  <mat-icon class="s-6">
                    visibility
                  </mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="tw-font-normal text-uppercase tw-text-sm tw-text-grey-300">
          {{ device.type }}
        </div>
      </div>
    </section>
  </ng-container>

  <ng-template
    #deviceStatusTemplate
    let-device>
    <mat-chip class="text-transparent {{ device.telemetryStateCssClass }}">
      {{ device.telemetryState | apply: convertTelemetryStatusToLabel }}
    </mat-chip>
  </ng-template>

  <ng-template #skeleton>
    <ion-skeleton-text
      id="device-list-title"
      animated
      class="w-50 h-14">
    </ion-skeleton-text>
    <section
      id="device-table"
      class="tw-w-full overflow-hidden border-1 tw-rounded tw-border-grey-100 fx-col">
      <div
        *ngFor="let _ of [].constructor(10)"
        class="fx-row fx-align-center fx-justify-between fx-gap-3 border-b-1 border-grey-100 p-1">
        <ion-skeleton-text
          *ngFor="let _ of [].constructor(4)"
          animated
          class="w-6p h-10">
        </ion-skeleton-text>
      </div>
    </section>

    <section
      id="device-list"
      class="tw-border-grey-100 border-1 tw-rounded-lg">
      <div
        *ngFor="let _ of [].constructor(10); let first = first"
        class="tw-flex tw-flex-col tw-p-2 tw-border-grey-100"
        [class.tw-border-t]="!first">
        <div class="tw-flex tw-justify-between tw-align-middle">
          <ion-skeleton-text
            animated
            class="w-50 h-10">
          </ion-skeleton-text>
          <ion-skeleton-text
            animated
            class="w-20 h-15">
          </ion-skeleton-text>
        </div>
        <ion-skeleton-text
          animated
          class="w-50 h-6">
        </ion-skeleton-text>
      </div>
    </section>
  </ng-template>

  <ng-template
    #content
    let-value="value">
    <ngx-copy-to-clipboard
      class="w-full"
      position="right"
      copiedTooltip="Copied"
      tooltip="Click to copy"
      [textToCopy]="value">
      <span class="ellipsed">
        {{ value }}
      </span>
    </ngx-copy-to-clipboard>
  </ng-template>
</ng-container>
